<ng-container *ngIf="showTracker && isDelta && showStaticTracker">
  <div class="static-flyout-tracker">
    <div
      class="tracker-static-description"
      [innerHTML]="trackerStaticDescription"
    ></div>
    <div class="explore-skymiles-button">
      <button
        (click)="openSkymilesPage()"
        class="btn-keep btn btn-outline-secondary-cta rounded-0 explore-skymiles"
      >
        {{ exploreSkymilesButtonLabel }}
      </button>
    </div>
  </div>
</ng-container>
<div
  *ngIf="showTracker && isDelta && !showStaticTracker"
  class="acctvty-tracker container-fluid"
  id="acctvtyTracker"
>
  <div class="col text-center authormessage authormessage-top">
    {{ topAuthorMsg }}
    <a class="medallion-status" href="{{ futureTierLink }}" target="_blank">
      {{ futureYrTier }}
      <span class="sr-only">Link opens in a new tab</span>
    </a>
  </div>
  <div class="col">
    <progressbar
      [max]="100"
      [value]="trackerData.currentYearMQM.percentTowardsNextTier"
      class="mqm-tracker progress"
      id="mqmTracker"
      type="info"
    ></progressbar>
    <div class="bartext">
      <span class="current-info" id="mqmTrackerCurrent">
        {{ barTexts.current[0] }}
      </span>
      <span class="needed-info text-uppercase" id="mqmTrackerNeeded">
        {{ barTexts.needed[0] }}
      </span>
    </div>
    <div class="max-info text-right" id="mqmTrackerMax">
      {{ barTexts.max[0] }}
    </div>
    <div
      *ngIf="!mileageReqChecked"
      aria-hidden="true"
      class="col flighticon icon-flight"
    ></div>
    <div
      *ngIf="mileageReqChecked"
      aria-hidden="true"
      class="col bluecheckicon icon-Checkround"
    ></div>
  </div>
  <div class="col mqscol">
    <progressbar
      [max]="100"
      [value]="trackerData.currentYearMQS.percentTowardsNextTier"
      class="mqs-tracker progress"
      id="mqsTracker"
      type="info"
    ></progressbar>
    <div class="bartext">
      <span class="current-info" id="mqsTrackerCurrent">
        {{ barTexts.current[1] }}
      </span>
      <span class="needed-info text-uppercase" id="mqsTrackerNeeded">
        {{ barTexts.needed[1] }}
      </span>
    </div>
    <div class="max-info text-right" id="mqsTrackerMax">
      {{ barTexts.max[1] }}
    </div>
  </div>
  <div *ngIf="showSpendRequirement" class="col">
    <progressbar
      [max]="100"
      [value]="trackerData.currentYearMQD.percentTowardsNextTier"
      class="mqd-tracker progress"
      id="mqdTracker"
      type="info"
    ></progressbar>
    <div class="bartext">
      <span class="current-info" id="mqdTrackerCurrent">
        {{ barTexts.current[2] }}
      </span>
      <span
        *ngIf="!showSpendCriteria"
        class="needed-info text-uppercase"
        id="mqsTrackerNeeded"
      >
        {{ barTexts.needed[2] }}
      </span>
    </div>
    <div class="max-info text-right" id="mqdTrackerMax">
      {{ barTexts.max[2] }}
    </div>
    <div
      *ngIf="!showSpendCriteria"
      aria-hidden="true"
      class="col dollaricon icon-dollar"
    ></div>
    <div
      *ngIf="showSpendCriteria"
      aria-hidden="true"
      class="col greencheckicon icon-Checkround"
    ></div>
  </div>
  <div *ngIf="showSpendRequirement" class="col">
    <progressbar
      [max]="100"
      [value]="trackerData.currentYearCardSpend.percentTowardsNextTier"
      class="cardspend-tracker progress"
      id="cardSpendTracker"
      type="info"
    ></progressbar>
    <div class="bartext">
      <span class="current-info" id="cardSpendTrackerCurrent">
        {{ barTexts.current[3] }}
      </span>
      <span
        *ngIf="!showSpendCriteria"
        class="needed-info text-uppercase"
        id="cardSpendTrackerNeeded"
      >
        {{ barTexts.needed[3] }}
      </span>
    </div>
    <div class="max-info text-right" id="cardSpendTrackerMax">
      <a
        class="medallion-status"
        href="{{ cardSpendRangeLink }}"
        target="_blank"
      >
        {{ otherMqdWaiver }}
        <span class="sr-only">Link opens in a new tab</span>
      </a>
      {{ barTexts.max[3] }}
    </div>
    <div class="max-info text-right" id="cardSpendTrackerDiamondMax">
      <a
        class="medallion-status"
        href="{{ dmCardSpendRangeLink }}"
        target="_blank"
      >
        {{ dmMqdWaiver }}
        <span class="sr-only">Link opens in a new tab</span>
      </a>
      {{ barTexts.max[4] }}
    </div>
  </div>
  <div class="offscreen" id="offscreenTracker">{{ trackerOffscreenText }}</div>
</div>
<div
  *ngIf="showTracker && !isDelta"
  class="acctvty-tracker vs-tracker container-fluid"
  id="acctvtyTracker"
>
  <div
    *ngIf="showlifetimeStatus"
    [ngClass]="getClassNamesVS(membershipLevel)"
    class="col vsMedallionStatus"
  >
    Lifetime
    <br />
    <span>{{ medallionMemberDesc }}</span>
  </div>
  <div
    *ngIf="!showlifetimeStatus"
    [ngClass]="getClassNamesVS(membershipLevel)"
    class="col vsMedallionStatus"
  >
    {{ medallionMemberDesc }}
  </div>
  <div *ngIf="!showlifetimeStatus" aria-hidden="true" class="col mqscol">
    <div class="current-info" id="mqsTrackerCurrent">
      {{ availableBalanceVS }}
      <span class="tier-points">&nbsp;Tier Points</span>
    </div>
    <progressbar
      [max]="maxThreshold"
      [value]="availableBalanceVS"
      class="mqs-tracker progress"
      id="mqsTracker"
      type="info"
    ></progressbar>
    <div class="max-info" id="mqsTrackerMax">{{ tierLevelMsg }}</div>
  </div>
  <div class="account-section">
    <div class="member-label">
      <div class="accountSection-label">Member Since</div>
      <div class="miles-yr">&nbsp;{{ enrollmentDate | slice : 0 : 4 }}</div>
    </div>
    <div *ngIf="resAcctSumContent?.expirationDate" class="expiry-label">
      <div class="accountSection-label">
        {{ resAcctSumContent?.expirationDate }}
      </div>
      <div class="expiry-yr">
        &nbsp;{{ milesExpiryDate | date : 'dd MMMM yyyy' }}
      </div>
    </div>
  </div>
  <div class="url-section">
    <div class="tierPoint-url">
      <a *ngIf="tierPointDescription" href="{{ tierPointUrl }}" target="_blank">
        {{ tierPointDescription }}
        <span class="rightArrow">&nbsp;</span>
      </a>
    </div>
    <div class="medallion-url">
      <a *ngIf="medallionDescritpion" href="{{ medallionUrl }}" target="_blank">
        {{ medallionDescritpion }}
        <span class="rightArrow">&nbsp;</span>
      </a>
    </div>
  </div>
</div>
<div
  *ngIf="
    !showTracker &&
    aemErrorMsgDetails &&
    aemErrorMsgDetails?.errorMessageDescription
  "
  class="acctvty-error-container container-fluid p-0"
>
  <div class="col text-center service-error-content p-0">
    <p>
      <span class="icon-alert-icon">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
      {{ aemErrorMsgDetails?.errorMessageDescription }}
    </p>
  </div>
</div>
<div *ngIf="spinner && !showStaticTracker" class="spinner-overlay"></div>
<div *ngIf="spinner && !showStaticTracker" class="spinner-loading">
  <div class="loader-holder"></div>
  <h2>Loading...</h2>
</div>
